import axios from "axios";
import {  authHeaderJson } from "./auth-header.service";

//Used
const getUserConnectionsPerMonth = async (userName) => {
  const data = JSON.stringify(userName);
  const config = { method: 'post', url: `/api/chart/get-user-connections-per-month`, headers: authHeaderJson(), data : data };
  return await axios(config);
}

//Unused
const getUserConnectionsPerYear = async (userName) => {
  const data = JSON.stringify(userName);
  const config = { method: 'post', url: `/api/chart/get-user-connections-per-year`, headers: authHeaderJson(), data : data };
  return await axios(config);
}

//Used
const getClientConnectionsPerMonth = async (clientId) => {
  const data = JSON.stringify(clientId);
  const config = { method: 'post', url: `/api/chart/get-client-connections-per-month`, headers: authHeaderJson(), data : data };
  return await axios(config);
}

//Unused
const getClientConnectionsPerYear = async (clientId) => {
  const data = JSON.stringify(clientId);
  const config = { method: 'post', url: `/api/chart/get-client-connections-per-year`, headers: authHeaderJson(), data : data };
  return await axios(config);
}

//Used
const getClientConnectionByCompanyType = async (clientId) => {
  const data = JSON.stringify(clientId);
  const config = { method: 'post', url: `/api/chart/get-client-connections-per-company-type`, headers: authHeaderJson(), data : data };
  return await axios(config);
}

//Used
const getAllClientYearConnections = async () => {
  const config = { method: 'post', url: `/api/chart/get-all-client-year-connections`, headers: authHeaderJson(), data : null };
  return await axios(config);
}

//Used
const getAllClientUserCount = async () => {
  const config = { method: 'post', url: `/api/chart/get-all-client-user-count`, headers: authHeaderJson(), data : null };
  return await axios(config);
}

//Used
const getAllClientRoleCount = async (clientId) => {
  const url = clientId !== null? `/api/chart/get-all-client-role-count?clientId=${clientId}` : `/api/chart/get-all-client-role-count`
  const config = { method: 'post', url: url, headers: authHeaderJson(), data : clientId };
  return await axios(config);
}

//Used
const getUserPermission = async (userName) => {
  const data = JSON.stringify(userName);
  const config = { method: 'post', url: `/api/chart/get-user-permissions`, headers: authHeaderJson(), data : data };
  return await axios(config);
}

//Used
const getAllClientLAstMonthConnections = async () => {
  const config = { method: 'post', url: `/api/chart/get-all-client-last-month-connections`, headers: authHeaderJson(), data : null };
  return await axios(config);
}

//Unused
const getClientLastMonthConnections = async () => {
  const config = { method: 'post', url: `/api/chart/get-client-last-month-connections`, headers: authHeaderJson(), data : null };
  return await axios(config);
}

const getUserConnections = async () => {
  const config = { method: 'post', url: `/api/chart/get-users-connections`, headers: authHeaderJson(), data : null };
  return await axios(config);
}

const getUsersStatus = async () => {
  const config = { method: 'post', url: `/api/chart/get-users-status`, headers: authHeaderJson(), data : null };
  return await axios(config);
}

export default {
  getUserConnectionsPerMonth,
  getUserConnectionsPerYear,
  getClientConnectionsPerMonth,
  getClientConnectionsPerYear,

  getClientConnectionByCompanyType,

  getAllClientYearConnections,
  getAllClientUserCount,
  getAllClientRoleCount,
  getUserPermission,
  getAllClientLAstMonthConnections,
  getClientLastMonthConnections,
  getUserConnections,
  getUsersStatus
};